import ServiceCard from './ServiceCard';

export default ServiceCard;
export type { ServiceCardProps } from './ServiceCard';
